import React from 'react';
import { Hexagon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-primary text-slate-300 py-12 border-t border-white/10" data-id="element-79">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-80">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-81">
          <div data-id="element-82">
            <a href="#" className="flex items-center gap-2 mb-4 group inline-flex" data-id="element-83">
              <Hexagon className="w-6 h-6 text-accent group-hover:rotate-90 transition-transform duration-500" data-id="element-84" />
              <span className="text-xl font-bold text-white tracking-tight" data-id="element-85">
                AlUniversalApps
              </span>
            </a>
            <p className="text-sm text-slate-400 max-w-sm" data-id="element-86">
              Transforming businesses through cutting-edge AI, mobile
              development, and production-grade engineering solutions.
            </p>
          </div>

          <div data-id="element-87">
            <h4 className="text-white font-semibold mb-4" data-id="element-88">Services</h4>
            <ul className="space-y-2 text-sm" data-id="element-89">
              <li data-id="element-90">
                <a href="#services" className="hover:text-accent transition-colors" data-id="element-91">
                  AI & Machine Learning
                </a>
              </li>
              <li data-id="element-92">
                <a href="#services" className="hover:text-accent transition-colors" data-id="element-93">
                  Mobile App Development
                </a>
              </li>
              <li data-id="element-94">
                <a href="#services" className="hover:text-accent transition-colors" data-id="element-95">
                  Frontend Development
                </a>
              </li>
              <li data-id="element-96">
                <a href="#services" className="hover:text-accent transition-colors" data-id="element-97">
                  Backend & System Design
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-98">
            <h4 className="text-white font-semibold mb-4" data-id="element-99">Company</h4>
            <ul className="space-y-2 text-sm" data-id="element-100">
              <li data-id="element-101">
                <a href="#about" className="hover:text-accent transition-colors" data-id="element-102">
                  About Us
                </a>
              </li>
              <li data-id="element-103">
                <a href="#why-us" className="hover:text-accent transition-colors" data-id="element-104">
                  Why Choose Us
                </a>
              </li>
              <li data-id="element-105">
                <a href="#contact" className="hover:text-accent transition-colors" data-id="element-106">
                  Contact
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 text-center text-sm text-slate-500" data-id="element-107">
          <p data-id="element-108">
            &copy; {new Date().getFullYear()} AlUniversalApps. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}